// src/stores/testStore.js
import { makeAutoObservable, runInAction } from 'mobx';
import apiClient from '../utils/apiClient'; // <-- Импортируем наш настроенный клиент
import logger from '../utils/logger';

class TestStore {
    testMessage = ''; // Состояние для хранения ответа сервера
    isLoading = false;
    error = null;

    constructor() {
        makeAutoObservable(this);
    }

    // Action для выполнения тестового запроса
    async fetchTestData() {
        logger.log('🧪 TestStore: fetchTestData called');
        this.isLoading = true;
        this.error = null;
        this.testMessage = ''; // Сбрасываем предыдущее сообщение

        try {
            // Используем apiClient для GET-запроса
            // Interceptor автоматически добавит токен (если пользователь залогинен)
            const response = await apiClient.get('/api/test');

            logger.log('✅ TestStore: API Response received:', response.data);

            // Обновляем состояние в MobX
            runInAction(() => {
                this.testMessage = response.data.message; // Ожидаем { message: '...' }
                this.isLoading = false;
            });

        } catch (err) {
            logger.error('❌ TestStore: API Error:', err.response?.data || err.message);
            runInAction(() => {
                // Сохраняем ошибку для отображения
                this.error = err.response?.data?.error || err.message || 'Произошла ошибка';
                this.isLoading = false;
            });
        }
    }
}

const testStore = new TestStore();
export default testStore;